import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatedHamburgerButton"] */ "/vercel/path0/src/app/_components/animatedHamburguerButton/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterBlog"] */ "/vercel/path0/src/app/blog/_components/footer.tsx");
